// Librerias
import { useRef, useEffect } from "react";

// Otros

/**
 * Descripcion del hook: Este hook devuelve el estado del componente anterior.
 *
 * Implementacion: Se importa y se pasa el estado, por ejemplo:
 *   const prevCount = usePrevious(count);.
 *
 * https://usehooks.com/usePrevious/
 *
 * Bugs: 0
 */

function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
export default usePrevious;
